module.exports = __webpack_public_path__ + "img/底纹pattren@2x.27bcdf8b.png";